import React, { Component } from 'react';
import TableNew from '../../../../_components/common/TableNew';
import Settings from '../../../../_components/common/SettingsHeader';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import { countryListActions, sellerActions, getRelationList } from '../../../../_actions';
import { organisationAction } from '../../../../_actions/organisation.action';
import { connect } from 'react-redux';
import { orgFormData } from './orgFormData';
import { compareBy } from './CompareFunc'
import 'react-toastify/dist/ReactToastify.css';
import ModalNew from '../../../../_components/common/ModalNew';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';




class OrgTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organisation: '',
            modal: false,
            addOrgState: false,
            showHeading: false,
            currentModalId: 1,
            showModalView: true,
            sortType: false,
            relationGroupData: '',
            toastCounter: 0,
            addRelation: [],
            relationToggle: false,

            orgFormDataState: [...orgFormData]
        }
    }

    componentDidMount() {
        let that = this;
        const { dispatch } = this.props;


        dispatch(organisationAction.setIds({
            orgId: 0,
            sellerId: 0
        }))
        dispatch(countryListActions.getCountries());
        dispatch(sellerActions.getSellers());
        dispatch({ type: 'REQUEST_DEL_ORG' });
        dispatch(getRelationList.getRelationListHandler())
    }

    filterData = (data) => {
        this.setState({
            organisation: data
        });
    }

    toggleModal(showModal) {

        this.setState({
            addOrgState: showModal,
            relationToggle: false
        }, () => {
            this.setState({
                addOrgState: true
            })
        });
    }

    toggleAddOrgModal(showModal) {
        let addRelation = []
        this.props.relationListResponse.map(
            (relation, i) => {
                addRelation.push(
                    {
                        key: relation.assessor_name,
                        type: 'checkbox',
                        value: false,
                        valid: true,
                        elementConfig: {
                            name: relation.assessor_name,
                            label: relation.assessor_name,
                            status: relation.assessor_group_type

                        },
                        validation: {
                            required: false,
                            message: ""
                        }
                    }
                )
            }
        )
        this.setState({
            addRelation: addRelation,
            relationToggle: true,
            addOrgState: false
        })
    }

    toggleRelationGroup(showModal) {
        this.setState({
            relationToggle: false,
            addOrgState: true,
        })
    }

    toggleEntireRelationModal(showModal) {

        const { orgFormDataState } = this.state;

        orgFormDataState.map(val => {
            if (val.type !== 'hidden') {
                val.value = ''
                if (val.validation !== undefined) {
                    if (val.validation.required === true) {
                        val.valid = false
                    } else {
                        val.valid = true
                    }
                }
            }
        })
        this.setState({
            addRelationGroupState: showModal
        })
    }

    currentModal(data) {
        this.setState({
            currentModalId: data,
            showModalView: !this.state.showModalView
        })
    }

    getModalSubmit(data) {

        let valueArray = []
        for (let j in data.sellerData.relation_list) {
            for (let i in this.props.relationListResponse) {
                if (this.props.relationListResponse[i].assessor_name === data.sellerData.relation_list[j]) {
                    valueArray.push(this.props.relationListResponse[i].id);
                }
            }
        }
        data.sellerData.relation_list = valueArray;

        const fd = data.sellerData;
        const seller_id = localStorage.getItem('seller_id')
        const userType = localStorage.getItem('usertype')

        const formData = {
            'address': fd.address,
            'city': fd.city,
            'country_name': fd.country_name,
            'organisation_name': fd.organisation_name,
            'organisation_code': fd.organisation_code,
            'pincode': fd.pincode === "" || fd.pincode === 0 ? null : parseInt(fd.pincode, 10),
            'assessor_group': fd.relation_list,
            'seller_name': seller_id !== 'null' && !userType.includes('super_admin') ? seller_id : fd.seller_name,
            'state': fd.state
        }



        this.props.dispatch(organisationAction.addOrganisation(formData, (add_org_data) => {
            const { orgFormDataState } = this.state;
            orgFormDataState.map(val => {
                val.value = ''
            })
        }))
    }

    sortBy(columnKey, type, tableName) {
        if (tableName === 'organisationTable') {
            this.setState({ sortType: type })
            const arrayCopy = this.state.relationGroupData === '' ? this.props.organisation : this.state.relationGroupData;
            arrayCopy.sort(compareBy(columnKey, this.state.sortType));
            this.setState({ relationGroupData: arrayCopy })
        }
    }

    componentDidUpdate(prevProps) {
        const { dispatch } = this.props;
        if (prevProps.organisation !== this.props.organisation) {
            if (this.props.organisation !== '') {
                if (!this.props.orgAddError && !this.props.orgAddLoading) {

                }

            }
        }
    }


    render() {

        const formData = [{
            key: 'seller_name',
            type: 'select',
            value: '',
            valid: false,
            regex: "^\\d+$",
            elementConfig: {
                name: 'seller_name',
                label: 'Seller Name',
                options: [],
                storeKey: ['seller', 'seller', 'data', 'seller_list']
            },
            validation: {
                required: true,
                message: "should be choosen"
            },

        }, {
            key: 'organisation_name',
            type: 'text',
            value: '',
            valid: false,
            fieldValid: true,

            elementConfig: {
                name: 'organisation_name',
                label: 'Name',
                placeholder: 'Organisation Name PVT LTD'
            },
            validation: {
                required: true,
                message: "is required"

            },
            fieldValidation: {
                required: "^(?:[a-zA-Z0-9 ]*)?$",
                message: "is invalid"
            }
        }, {
            key: 'organisation_code',
            type: 'text',
            value: '',
            valid: false,
            regex: ".+",
            elementConfig: {
                name: 'organisation_code',
                label: 'Code',
                placeholder: 'ORG'
            },
            validation: {
                required: true,
                message: "is required"
            },
        }, {
            key: 'address',
            type: 'text',
            value: '',
            valid: false,
            regex: ".+",
            elementConfig: {
                name: 'address',
                label: 'Address',
                placeholder: ''
            },
            validation: {
                required: true,
                message: "is required"
            },
        }, {
            key: 'city',
            type: 'text',
            value: '',
            valid: true,
            regex: ".+",
            elementConfig: {
                name: 'city',
                label: 'City',
                placeholder: ''
            },
            validation: {
                required: false,
                message: "is required"
            },
        }, {
            key: 'pincode',
            type: 'pincodeText',
            value: '',
            valid: true,
            regex: "^\d{6}$",
            elementConfig: {
                name: 'pincode',
                label: 'Pin Code',
                placeholder: ''
            },
            validation: {
                required: true,
                message: "is required"
            },
            fieldValidation: {
                required: "^\d{6}$",
                message: "Pincode is invalid"
            }
        }, {
            key: 'state',
            type: 'text',
            value: '',
            valid: true,
            regex: "^[a-zA-Z]+$",
            elementConfig: {
                name: 'state',
                label: 'State',
                placeholder: ''
            },
            validation: {
                required: false,
                message: "is required"
            },
        }, {
            key: 'country_name',
            type: 'select',
            value: '',
            valid: true,
            regex: "^\\d+$",
            elementConfig: {
                name: 'country_name',
                label: 'Country',
                options: [],
                storeKey: ['countries', 'countries']
            },
            validation: {
                required: false,
                message: "Country is required"
            },
        }, {
            key: 'relation_list',
            type: 'hidden',
            value: '',
            valid: true,
            elementConfig: {
                name: 'relation_list',
                label: '',
            },
            validation: {
                required: false,
                message: ''
            }
        },
        ]


       

        const { heading } = this.props;
        const { load } = this.props;
        const { loading, error } = this.props;
        const { organisation, orgAddText, orgAddError, orgAddLoading } = this.props;



        const filteredData = this.state.organisation === '' ? organisation : this.state.organisation;



        const columns = [
            {
                id: 1,
                name: 'Name',
                key: 'organisation_name',
                link: 'organisation/',
                sort: true,
            },
            {
                id: 2,
                name: 'Code',
                key: 'organisation_code',
                link: '',
                sort: true,
            },
            {
                id: 3,
                name: 'Seller',
                key: 'seller__seller_name',
                link: '',
                sort: true,
            },
            {
                id: 4,
                name: 'City',
                key: 'city',
                link: '',
                sort: true,
            },
            {
                id: 5,
                name: 'Country',
                key: 'country__country_name',
                link: '',
                sort: true,
            }
        ];

        const { countries } = this.props;
        const { Sellers } = this.props;
        const seller_id = localStorage.getItem('seller_id');
        const userType = localStorage.getItem('usertype');

        const { orgFormDataState } = this.state;

        if (userType.includes('super_admin')) {

            orgFormDataState.map(function (element) {

                if (element.key === 'country_name') {
                    element.elementConfig.options = countries;
                }
                if (element.key === 'seller_name') {
                    element.elementConfig.options = Sellers;
                }
            });
        }
        if (!userType.includes('super_admin')) {


            orgFormDataState.map(function (element) {

                if (element.key === 'country_name') {
                    element.elementConfig.options = countries;
                }
                if (element.key === 'seller_name') {
                    orgFormDataState.splice(0, 1);
                }
            });
        }


        const buttonDataProp = [
            {
                id: 1,
                heading: "Add New Organisation",
                togglerModal: this.state.addOrgState,
                toggler: this.toggleAddOrgModal.bind(this),
            }
        ]


        return (
            <div>
                <div className="">
                    <CommonBreadCrumb
                        data={[
                            {
                                link: '/admin/app/dashboard',
                                name: 'ADMIN'
                            }, {
                                link: '',
                                name: 'ORGANISATION'
                            }
                        ]}
                    />
                    <div className="bg-green rounded-top">
                        {
                            (!loading && !error) ?
                                <p className="text-center text-uppercase py-2 text-white mb-0"> {heading} </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="text-center text-uppercase py-2 text-white mb-0"> {heading} </p>
                                    <LoaderComp color={'white'} />
                                </div>
                        }
                    </div>

                </div>
                {
                    (!loading && !error) &&
                    <div >
                        <Settings

                            buttonData={buttonDataProp}


                            columns={columns}

                            sellers={organisation}

                            view={this.filterData.bind(this)}

                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.addOrgState}
                            filter={true}
                            widthClass={'col-md-6'}
                        />

                        <TableNew

                            data={filteredData}

                            columns={columns}

                            showSlNo="true"

                            sortBy={(key) => this.sortBy(key, !this.state.sortType, 'organisationTable')}
                            sortType={this.state.sortType}
                        />


                    </div>
                }

                {
                    this.state.addOrgState &&
                    <ModalNew

                        heading="Organisation details"
                        modalName="nonSubmittableForm"

                        showModal={this.state.addOrgState}

                        formData={orgFormDataState}

                        selects={['seller_name', 'country_name']}

                        relationToggle={this.toggleAddOrgModal.bind(this)}

                        selectKey={['id', 'id']}
                        toggleEntireModal={this.toggleEntireRelationModal.bind(this)}

                    />
                }

                {
                    this.state.relationToggle &&
                    <ModalNew
                        modalName="inlineCheckbox2"
                        heading="Relation Groups"
                        showModal={this.state.relationToggle}
                        toggleRelationGroup={this.toggleRelationGroup.bind(this)}

                        formData={this.state.addRelation}
                        action={this.getModalSubmit.bind(this)}

                        toggleEntireModal={this.toggleEntireRelationModal.bind(this)}
                        compartments={{
                            key: 'assessor_group_type',
                            name: 'assessor_name',
                            compartmentData: [
                                {
                                    name: 'Professional',
                                    value: true
                                },
                                {
                                    name: 'Personal',
                                    value: false
                                }
                            ]
                        }}
                    />
                }
            </div>
        );
    }
}


function mapStateToProps(state) {
    const loadingCountry = state.countries.loading;
    const errorCountry = state.countries.error;
    const loadingSeller = state.seller.loading;
    const errorSeller = state.seller.error;
    const { loading, error } = state.organisation
    const countries = (!loadingCountry && !errorCountry) ? state.countries.countries : '';
    const Sellers = (!loadingSeller && !errorSeller) ? state.seller.seller.data.seller_list : '';

    const { orgAddError, orgAddLoading, orgAddText } = state.addOrganisation


    const { delOrgError, delOrgLoading, delOrgMessage } = state.deleteOrgState;

    const organisation = (!loading && !error) ? state.organisation.organisation.data.organisation_list : '';



    const { RelationListLoading } = state.relationList;
    const relationListResponse = (!RelationListLoading) ? state.relationList.data.data.results : '';
    const relationListResponseCode = (!RelationListLoading) ? state.relationList.data.status : '';

    return {
        error,
        loading,
        countries,
        Sellers,
        organisation,
        orgAddError,
        orgAddLoading,
        orgAddText,
        delOrgError,
        delOrgLoading,

        relationListResponse,
        relationListResponseCode,
    };
}

export default connect(mapStateToProps)(OrgTable);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/component/orgTable.js